export default __webpack_public_path__ + "static/media/horse.9c781a1d.png";